module.exports = __webpack_public_path__ + "img/DAPChart4.6cb76976.png";